import { ref } from 'vue'
import { defineStore } from 'pinia'
import { localStorage } from '@shared/helpers/storage'
import type { StorageLike } from 'pinia-plugin-persistedstate'

export const useAutofillStore = defineStore(
  'autofill',
  () => {
    const enabled = ref(true)
    const fields = ref({
      email: 'john.doe@kaiahealth.com',
      password: 'ssssssS!',
      firstName: 'John',
      lastName: 'Doe',
      phone: '+4915123456789',
      dob: '2000-02-02',
    })

    return { enabled, fields }
  },
  {
    persist: {
      storage: localStorage as unknown as StorageLike,
    },
  },
)

export default useAutofillStore
